import ComparableCompanyListItem from './ComparableCompanyListItem';

/**
 * ComparableCompaniesListView - List view for comparable companies
 *
 * Renders ComparableCompanyListItem for each company in sortedCompanies array.
 * Note: ComparableCompanyDataRow (target company) is rendered in the header components
 * to ensure the divider line appears below it (inside results-header-wrap).
 *
 * This is the view component for the "list" display mode.
 */
const ComparableCompaniesListView = ({
  sortedCompanies,
  layout,
  project,
  profilerAccessStore,
  profilerProjectStore,
  utilsStore,
  onCompanyDetailsClick,
  onWatchlistClick
}) => {
  // Deduplicate companies by ID to prevent React key warnings
  const seenIds = new Set();
  const uniqueCompanies = sortedCompanies.filter((company) => {
    if (seenIds.has(company.id)) {
      return false;
    }
    seenIds.add(company.id);
    return true;
  });

  return (
    <>
      {/* List of similar companies */}
      {uniqueCompanies.map((company) => (
        <ComparableCompanyListItem
          key={company.id}
          company={company}
          layout={layout}
          project={project}
          profilerAccessStore={profilerAccessStore}
          profilerProjectStore={profilerProjectStore}
          utilsStore={utilsStore}
          onCompanyDetailsClick={onCompanyDetailsClick}
          onWatchlistClick={onWatchlistClick}
        />
      ))}
    </>
  );
};

export default ComparableCompaniesListView;
